import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { EventNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { FilterDetailList, FiltersLeadIn, hasFilters, Times, Within } from '../condition-parts';

type EventConditionProps = { node: EventNode };

export function EventCondition({ node }: EventConditionProps) {
  const operator = node.inverse ? 'not performed' : 'performed';
  return (
    <ConditionViewerItem
      icon={getIconForNode(node)}
      details={hasFilters(node.filters) ? <FilterDetailList filters={node.filters} /> : undefined}
    >
      <ConditionViewerTerm>{node.name}</ConditionViewerTerm> {operator}
      <Times times={node.times} />
      <Within within={node.within} />
      <FiltersLeadIn filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionViewerItem>
  );
}
